var RENDERS;
(function (RENDERS) {
    RENDERS["ANNOUNCE_DATE_TIME"] = "MA_ANNOUNCE_DATE_TIME.render";
    RENDERS["TITLE"] = "MA_TITLE.render";
    RENDERS["PARENT_OF_PURCHASER_ENTITY"] = "MA_PARENT_OF_PURCHASER_ENTITY.render";
    RENDERS["PURCHASER_ENTITY"] = "MA_PURCHASER_ENTITY.render";
    RENDERS["TARGET_ENTITY"] = "MA_TARGET_ENTITY.render";
    RENDERS["PARENT_OF_TARGET_ENTITY"] = "MA_PARENT_OF_TARGET_ENTITY.render";
    RENDERS["STATUS"] = "MA_STATUS.render";
    RENDERS["PRIMARY_DEAL_TYPE"] = "MA_PRIMARY_DEAL_TYPE.render";
    RENDERS["PERCENT_TOTAL"] = "MA_PERCENT_TOTAL.render";
    RENDERS["TRANSACTION_VALUE"] = "MA_TRANSACTION_VALUE.render";
    RENDERS["BASE_EQUITY"] = "MA_BASE_EQUITY.render";
    RENDERS["ENTERPRISE_VALUE"] = "MA_ENTERPRISE_VALUE.render";
    RENDERS["PERCENT_SOUGHT"] = "MA_PERCENT_SOUGHT.render";
    RENDERS["PAYMENT_TYPE"] = "MA_PAYMENT_TYPE.render";
    RENDERS["NORMALIZED_TOPIC"] = "MA_NORMALIZED_TOPIC.render";
})(RENDERS || (RENDERS = {}));
export const MERGER_COLUMNS_MAP = {
    ANNOUNCE_DATE_TIME: {
        renderer: RENDERS.ANNOUNCE_DATE_TIME,
        width: 160,
    },
    TITLE: {
        renderer: RENDERS.TITLE,
        width: 360,
    },
    PARENT_OF_PURCHASER_ENTITY: {
        renderer: RENDERS.PARENT_OF_PURCHASER_ENTITY,
        width: 200,
    },
    PURCHASER_ENTITY: {
        renderer: RENDERS.PURCHASER_ENTITY,
        width: 240,
    },
    TARGET_ENTITY: {
        renderer: RENDERS.TARGET_ENTITY,
        width: 240,
    },
    PARENT_OF_TARGET_ENTITY: {
        renderer: RENDERS.PARENT_OF_TARGET_ENTITY,
        width: 240,
    },
    STATUS: {
        renderer: RENDERS.STATUS,
        width: 200,
    },
    PRIMARY_DEAL_TYPE: {
        renderer: RENDERS.PRIMARY_DEAL_TYPE,
        width: 200,
    },
    PERCENT_TOTAL: {
        renderer: RENDERS.PERCENT_TOTAL,
        width: 200,
    },
    TRANSACTION_VALUE: {
        renderer: RENDERS.TRANSACTION_VALUE,
        width: 200,
    },
    BASE_EQUITY: {
        renderer: RENDERS.BASE_EQUITY,
        width: 200,
    },
    ENTERPRISE_VALUE: {
        renderer: RENDERS.ENTERPRISE_VALUE,
        width: 200,
    },
    PERCENT_SOUGHT: {
        renderer: RENDERS.PERCENT_SOUGHT,
        width: 200,
    },
    PAYMENT_TYPE: {
        renderer: RENDERS.PAYMENT_TYPE,
        width: 200,
    },
    NORMALIZED_TOPIC: {
        renderer: RENDERS.NORMALIZED_TOPIC,
        width: 200,
    },
};
